// @ts-ignore
import { isHTMLString as _isHTMLString } from "@my-scoot/exly-react-component-lib/build/cjs/features/Common/modules/DataTypes/utils/strings";
import { isHTMLString as IIsHTMLStringType } from "@my-scoot/exly-react-component-lib/build/types/features/Common/modules/DataTypes/utils/strings";
import type { pluralise as PluraliseType } from "@my-scoot/exly-react-component-lib/build/types/utils/common/dataTypes/string";
// @ts-ignore
import { pluralise as _pluralise } from "@my-scoot/exly-react-component-lib/build/cjs/utils/common/dataTypes/string";
import { SEPARATE_COUNTRY_CODE_PHONE_NUMBER } from "../constants/regex";

type IPluralise = typeof PluraliseType;
const pluralise: IPluralise = _pluralise;
export { pluralise };

/**
 * Given a complete phone number like '+91 8899988999', this util separates
 * the countr code '+91' and phone number '8899988999' and returns it
 * @param completePhoneNumber This is the complete phone number containing bothe country code and phone number
 * @returns object containing both countryCode and phoneNumber
 */
export const getCountryCodeAndPhoneNumber = (completePhoneNumber: string) => {
    // Use the pattern to execute the regular expression on the string
    const match = completePhoneNumber.match(SEPARATE_COUNTRY_CODE_PHONE_NUMBER);

    if (match?.length) {
        const countryCode = match[1];
        const phoneNumber = match[2];
        return { countryCode, phoneNumber };
    }
    return {
        countryCode: "",
        phoneNumber: "",
    };
};

export const isHTMLString: typeof IIsHTMLStringType = _isHTMLString;
